import {
  sendWappLoadingTimeAnalytics,
  sendWappRunningTimeAnalytics,
} from './analytics.helper'

const sessionTimes: Record<string, { startTime: number; runTime?: number }> = {}

export const resetWappSessionTime = (wappSessionId: string) => {
  delete sessionTimes[wappSessionId]
}

export const submitWappSessionStartTime = (wappSessionId: string) => {
  sessionTimes[wappSessionId] = { startTime: Date.now() }
}

export const submitWappSessionRunTime = (wappSessionId: string) => {
  const sessionStartTime = sessionTimes[wappSessionId]?.startTime
  if (!sessionStartTime) return

  const sessionRunTime = Date.now()
  sessionTimes[wappSessionId].runTime = sessionRunTime

  const loadingDuration = sessionRunTime - sessionStartTime
  sendWappLoadingTimeAnalytics({ wappSessionId, duration: loadingDuration })
}

export const stopWappSessionTime = (wappSessionId: string) => {
  const sessionRunTime = sessionTimes[wappSessionId]?.runTime
  if (!sessionRunTime) return

  const runningDuration = Date.now() - sessionRunTime
  sendWappRunningTimeAnalytics({ wappSessionId, duration: runningDuration })
  resetWappSessionTime(wappSessionId)
}
